import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

const allowedPaths = [
  '/login',
  '/choose-business',
  '/not-found',
  '/reset',
  '/free-trial-ended',
  '/permissions-needed',
  '/sso',
  '/create-new-business',
  '/payment-required',
  '/settings/billing',
];

// We need to allow business info, in case they haven't added a credit card yet and
// don't have a business address set (which is required for credit cards)
const businessSettingsPattern = /^\/settings\/business$/;

export const BillingRouting = () => {
  const location = useLocation();
  const history = useHistory();
  const business = useSelector((s: any) => s.authentication.chosenBusiness);

  const isBlocked = business?.billing_status === 'blocked_new';

  const { pathname } = location;

  useEffect(() => {
    if (businessSettingsPattern.test(pathname)) {
      return;
    }

    const isAlwaysAllowedPath = allowedPaths.some((allowed) =>
      pathname.startsWith(allowed)
    );

    if (isAlwaysAllowedPath) {
      return;
    }

    if (isBlocked) {
      history.replace('/payment-required');
    }
  }, [pathname, history, isBlocked]);

  return null;
};
